"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const immutable_1 = require("immutable");
const SupportingCreativeFormatFastStartItem_1 = require("./SupportingCreativeFormatFastStartItem");
class SupportingCreativeFormatFastStart {
    constructor({ availables }) {
        this.toJSON = () => ({
            availables: this.availables.toJSON(),
        });
        this.availables = availables;
    }
}
SupportingCreativeFormatFastStart.fromJSON = (json) => {
    const { availables } = Object.assign({}, json);
    if (!Array.isArray(availables))
        throw new Error('.availables must be an array');
    return new SupportingCreativeFormatFastStart({
        availables: immutable_1.List(availables).map((item) => SupportingCreativeFormatFastStartItem_1.default.fromJSON(item)),
    });
};
exports.default = SupportingCreativeFormatFastStart;
